import { StyleSheet, css, Style } from "@design-system/style-sheet"
import { NamedStyles } from "../types"

export function createStyleSheet<T>(styles: NamedStyles<T>) {
  return StyleSheet.create(styles)
}

export function compileCSS(styles: { [key: string]: Style }) {
  return css.create(styles)
}
